import { ObjectField } from ".";
import { PartnerType } from "./PartnerType";
export class PartnerTypeFieldsPermission {
    Id: number | null;
    Tenant: number;
    PartnerTypeCode: string;
    PartnerType:PartnerType |null;
    ObjectFieldCode: string | null;
    ObjectTableCode: string | null;
    ObjectField: ObjectField | null;
    Read: boolean;
    Write: boolean;
}